'use strict';

const cache = new Map();
const isDomReady = () =>
  document.readyState === 'interactive' || document.readyState === 'complete';

/**
 * Based on the popular npm library `element-ready`:
 *  - https://www.npmjs.com/package/element-ready
 * On this specific commit:
 *  - https://github.com/sindresorhus/element-ready/blob/390c1e04075034a7c7ef9ad15d4105d35c732119/index.js
 *
 * MIT License
 *
 * Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)
 *
 * We are pulling in the source code and modifying to suit, as our build process fails
 * to minify with:
 *    Failed to minify the code from this file:
 *        ./node_modules/element-ready/index.js:6
 *
 * Possibly due to the presence of modern JavaScript according to:
 * - https://create-react-app.dev/docs/troubleshooting/#npm-run-build-fails-to-minify
 *
 * The goal here to not re-invent the wheel but to use an existing solution
 * with minimum amount of effort.
 *
 * @param {string} selector CSS query selector
 * @param {object} param1 In the form of:
 *  {
 *      target: Element (default document),
 *      stopOnDomReady: boolean (default true),
 *      timeout: Number (default Infinity)
 * }
 * @return {Promise} Promise that either resolves with element on success, or undefined on timeout/cancelled.
 */
const elementReady = (
  selector,
  { target = document, stopOnDomReady = true, timeout = Infinity } = {}
) => {
  const cacheKey = selector;
  const cachedPromise = cache.get(cacheKey);
  if (cachedPromise) {
    return cachedPromise;
  }

  let rafId;
  const deferred = {};
  const promise = new Promise((resolve) => {
    deferred.resolve = (element) => {
      resolve(element);
    };
  });

  cache.set(cacheKey, promise);

  const stop = () => {
    cancelAnimationFrame(rafId);
    cache.delete(cacheKey, promise);
    deferred.resolve();
  };

  if (timeout !== Infinity) {
    setTimeout(stop, timeout);
  }

  // Interval to keep checking for it to come into the DOM.
  (function check() {
    const element = target.querySelector(selector);

    if (element) {
      deferred.resolve(element);
      stop();
    } else if (stopOnDomReady && isDomReady()) {
      stop();
    } else {
      rafId = requestAnimationFrame(check);
    }
  })();

  return Object.assign(promise, { stop });
};

export default elementReady;



// WEBPACK FOOTER //
// ./src/lib/elementReady.js